export const getElementHeight = (domId: string) => document.getElementById(domId)?.clientHeight ?? 0;
export const getElementWidth = (domId: string) => document.getElementById(domId)?.clientWidth ?? 0;
